import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../../utils/config";
import { adminRequest } from "../../../utils/requestMethods";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomForm from "../../../components/CustomForm/CustomForm";

const CreateEnrollmentSetup = () => {
  const initialFormData = {
    academicYear: "",
    enrollmentBatch: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/enrollmentSetup/create`, {
          academicYear: formData.academicYear,
          enrollmentBatch: formData.enrollmentBatch,
        }),
        {
          pending: "Processing your request",
        }
      );

      toast.success(response.data.message, {
        autoClose: 500,
        onClose: () => navigate(-1),
      });

      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const fields = [
    {
      name: "academicYear",
      label: "Academic Year",
      tail: "e.g 2025",
      type: "text",
      value: formData.academicYear,
      onChange: handleChange,
    },

    {
      name: "enrollmentBatch",
      label: "Enrollment Batch",
      tail: "e.g 2025-2029",
      type: "text",
      value: formData.enrollmentBatch,
      onChange: handleChange,
    },
  ];
  return (
    <div className="createEnrollmentSetupContainer">
      <CustomForm
        header="Create Enrollment Setup"
        fields={fields}
        flexDirection="column"
        createButtonLabel="Create"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default CreateEnrollmentSetup;
